import { useState, useEffect } from 'react';
export function useOnlineStatus() {
  const [o, setO] = useState(navigator.onLine);
  useEffect(() => { const on = () => setO(true); const off = () => setO(false); window.addEventListener('online', on); window.addEventListener('offline', off); return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); }; }, []);
  return o;
}
